module.exports = __webpack_public_path__ + "img/肌如初雪套装_08.ae7e3dcb.jpg";